// extracted by mini-css-extract-plugin
module.exports = {"content":"WorkoutHighlightsAndOverview_content__3Uw2l","heading":"WorkoutHighlightsAndOverview_heading__3inD4"};